import { z } from 'zod';

export const SalesProductSchema = z.object({
  imageUrl: z.string().url().describe('이미지 URL'),
  brandName: z.string().describe('브랜드명'),
  goodsNo: z.number().int().describe('상품 고유 번호'),
  goodsName: z.string().describe('상품명'),

  price: z.number().int().describe('가격'),

  totalQuantity: z.number().int().describe('해당 기간 판매 개수'),
  totalCommission: z.number().int().describe('해당 기간 수수료 합산 금액'), // 명세: int64
  linkUrl: z.string().describe('링크 URL'),
});

export const ProductSalesRankingResponseDTOSchema = z.object({
  total: z.number(),
  list: z.array(SalesProductSchema).describe('판매 랭킹 상품 리스트'),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.string().nullable(),
  }),
});

export type ProductSalesRankingResponseDTO = z.infer<typeof ProductSalesRankingResponseDTOSchema>;
